import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["content", "toggleButton"];
  static classes = ["open"];
  static values = { 
    open: Boolean, 
    direction: { type: String, default: "left" },
    width: { type: Number, default: 380 }
  };

  connect() {
    this.isOpen = this.openValue;

    if (this.isOpen) {
      this.showContent();
      this.element.classList.add(this.openClass);
    } else {
      this.hideContent();
      this.element.classList.remove(this.openClass);
    }

    this.updateAriaExpanded();
    this.dispatchWidth();
  }

  toggle() {
    this.isOpen = !this.isOpen;
    this.element.classList.toggle(this.openClass, this.isOpen);

    if (this.hasContentTarget) {
      if (this.isOpen) {
        this.showContent();
      } else {
        this.hideContent();
      }
    }

    this.updateAriaExpanded();
    this.dispatchWidth();
    this.dispatchToggleEvent();
  }

  updateAriaExpanded() {
    this.toggleButtonTarget.setAttribute("aria-expanded", this.isOpen.toString());
  }

  dispatchWidth() {
    const width = this.isOpen ? this.widthValue : 40;
    this.dispatch("widthChanged", { detail: { drawerId: this.element.id, width } });
  }

  dispatchToggleEvent() {
    this.toggleButtonTarget.dispatchEvent(new CustomEvent("drawer:toggled", {
      bubbles: true,
      detail: { isOpen: this.isOpen }
    }));
  }

  showContent() {
    this.contentTarget.classList.remove("hidden");
    this.element.style.width = `${this.widthValue}px`;
    this.updateButtonSymbol();
  }

  hideContent() {
    this.contentTarget.classList.add("hidden");
    this.element.style.width = "40px";
    this.updateButtonSymbol();
  }

  updateButtonSymbol() {
    if (this.hasToggleButtonTarget) {
      switch (this.directionValue) {
        case "right":
          this.toggleButtonTarget.innerHTML = this.isOpen ? "&gt;" : "&lt;";
          break;
        case "left":
          this.toggleButtonTarget.innerHTML = this.isOpen ? "&lt;" : "&gt;";
          break;
        case "top":
          this.toggleButtonTarget.innerHTML = this.isOpen ? "&#9650;" : "&#9660;";
          break;
        case "bottom":
          this.toggleButtonTarget.innerHTML = this.isOpen ? "&#9660;" : "&#9650;";
          break;
        default:
          this.toggleButtonTarget.innerHTML = "";
          break;
      }
    }
  }
}
